export default "__VITE_ASSET__f1e893bc__"